import React from "react";
import { useTranslation } from 'react-i18next';
import styles from "./LogoutConfirmModal.module.scss";

interface LogoutConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const LogoutConfirmModal: React.FC<LogoutConfirmModalProps> = ({ isOpen, onClose, onConfirm }) => {
  const { t } = useTranslation();
  
  if (!isOpen) return null;
  
  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        <p className={styles.message}>{t('logoutConfirm.content')}</p>
        <div className={styles.buttonContainer}>
          <button 
            className={styles.cancelButton}
            onClick={onClose}
          >
            {t('logoutConfirm.close')}
          </button>
          <button 
            className={styles.logoutButton}
            onClick={onConfirm}
          >
            {t('logoutConfirm.logout')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogoutConfirmModal;
